module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img8.eea60b1b.jpg";